import * as React from 'react';
import { ReactNode } from 'react';
import { ValidationResult } from '../../../../util/validation/interfaces';
import { ApiResponse, PublisherDTO, SolrDocument, SuggestApi } from '../../../../api/core';
import { Suggester } from './Suggester';

interface Props {
  value: PublisherDTO[];
  onChange?: (values: PublisherDTO[]) => void;
  multiple: boolean;
  disabled?: boolean;
  required?: boolean;
  validation?: ValidationResult;
  inputId?: string;
  autoFocus?: boolean;
  border?: 'border-noround' | 'border-noround-right';
  tooltip?: string;
  tooltipOptions?: any;
}

interface PublisherResponse {
  id: string;
  publisher_name: string;
}


export function PublisherSuggester(props: Props): ReactNode {
  const request = (params: { q: string }): Promise<ApiResponse<SolrDocument[]>> =>
    new SuggestApi().publisherSuggestRaw(params);


  const itemTemplate = (item: PublisherDTO): ReactNode => {
    return <div className={'max-w-30rem flex'}>{item.name}</div>;
  };

  return (
    <Suggester<PublisherDTO, PublisherDTO>
      itemTemplate={itemTemplate}
      autoFocus={props.autoFocus}
      selectedItemTemplate={itemTemplate}
      load={request}
      map={(result: PublisherResponse): PublisherDTO => ({id: +result.id, name: result.publisher_name})}
      inputId={props.inputId}
      value={props.value}
      disabled={props.disabled}
      validation={props.validation}
      required={props.required}
      onChange={props.onChange}
      border={props.border}
      tooltip={props.tooltip}
      tooltipOptions={props.tooltipOptions}
      multiple={props.multiple}/>
  );
}
